import React from 'react';
import { SlideContainer } from '../SlideContainer';
import { FadeInStagger, FadeIn } from '../FadeIn';
export const Slide01Title = () => {
  return <SlideContainer centered data-id="element-14">
      <FadeInStagger className="max-w-4xl flex flex-col items-center justify-center space-y-8" data-id="element-15">
        <FadeIn data-id="element-16">
          <div className="inline-flex items-center justify-center px-3 py-1 rounded-full border border-white/10 bg-white/[0.02] mb-4" data-id="element-17">
            <span className="text-xs font-medium tracking-wide text-white/60 uppercase" data-id="element-18">
              Confidential
            </span>
          </div>
        </FadeIn>

        <FadeIn data-id="element-19">
          <h1 className="text-6xl md:text-7xl lg:text-8xl font-bold tracking-tightest text-white" data-id="element-20">
            Master Ed
          </h1>
        </FadeIn>

        <FadeIn data-id="element-21">
          <h2 className="text-2xl md:text-3xl font-medium text-white/70 tracking-tight" data-id="element-22">
            Measure Comprehension, Not Completion
          </h2>
        </FadeIn>

        <FadeIn data-id="element-23">
          <div className="w-12 h-[1px] bg-accent-purple/50 my-8 mx-auto" data-id="element-24"></div>
        </FadeIn>

        <FadeIn data-id="element-25">
          <p className="text-sm md:text-base text-white/40 max-w-md mx-auto leading-relaxed text-center" data-id="element-26">
            A voice-first AI platform for learning through conversation
          </p>
        </FadeIn>
      </FadeInStagger>
    </SlideContainer>;
};